// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "list__item_selected-3r2lo";
var _4 = "list__item_icon-ye3va";
var _5 = "price-1a8AH";
var _6 = "meal-3AC5o";
var _7 = "meal__name-2os1Z";
var _8 = "count-3zDoF";
var _9 = "categories_mobile__title-f05iF";
var _a = "categories_mobile__header-2r291";
var _b = "slideBottom_container-3uTtN";
var _c = "categories__wrapper-Il9_a";
var _d = "categories__button-2uiIN";
var _e = "list_wrapper-2hfxF";
var _f = "list__item-31kAj";
export { _1 as "__esModule", _2 as "mobile", _3 as "list__item_selected", _4 as "list__item_icon", _5 as "price", _6 as "meal", _7 as "meal__name", _8 as "count", _9 as "categories_mobile__title", _a as "categories_mobile__header", _b as "slideBottom_container", _c as "categories__wrapper", _d as "categories__button", _e as "list_wrapper", _f as "list__item" }
export default { "__esModule": _1, "mobile": _2, "list__item_selected": _3, "list__item_icon": _4, "price": _5, "meal": _6, "meal__name": _7, "count": _8, "categories_mobile__title": _9, "categories_mobile__header": _a, "slideBottom_container": _b, "categories__wrapper": _c, "categories__button": _d, "list_wrapper": _e, "list__item": _f }
